import { render, staticRenderFns } from "./example-tool.vue?vue&type=template&id=c8ac71bc&scoped=true&"
import script from "./example-tool.vue?vue&type=script&lang=ts&"
export * from "./example-tool.vue?vue&type=script&lang=ts&"
import style0 from "./example-tool.vue?vue&type=style&index=0&id=c8ac71bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ac71bc",
  null
  
)

export default component.exports